
export default {
    name: 'article-loading-card'
}
